import React from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const isLoggedInToken = true;//localStorage.getItem('token');

  // const handleRouting = () => {
  //   isLoggedInToken ? navigate("/app/home") : navigate("/auth/login")
  // };

  return (
    <NotFoundContainer>
      <NotFoundInner>
        <NotFoundHeader>Oops! Page not found</NotFoundHeader>
        <SubWrapper>
          <NotFoundSub>
            We're sorry, the page you requested could not be found. Please go
            back to the homepage!
          </NotFoundSub>
        </SubWrapper>
      </NotFoundInner>
    </NotFoundContainer>
  );
};

const NotFoundContainer = styled.div`
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const NotFoundInner = styled.div`
  disply: flex;
  flex-direction: column;
  text-align: center;
`;

const Img404 = styled.img`
  width: 80%;
  @media only screen and (max-width: 768px) {
    width: 55%;
  }
`;

const NotFoundHeader = styled.div`
  font-size: 2.625rem;
  color: white;
  margin-top: 1.063rem;
  font-weight: 700;

  @media only screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

const SubWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.438rem 0 2.875rem;
`;
const NotFoundSub = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: white;
  width: 609px;

  @media only screen and (max-width: 768px) {
    font-size: 1.25rem;
    width: 100%;
  }
`;

export default NotFound;
